import assertUnreachable from '../utils/assertUnreachable';
import { AGENT_IDENTITY_SETTINGS_PATH, getProjectAgentIdentitySettingsPath, } from './agentIdentity';
import { getAgentCapabilityName, } from './agentPermissions';
export const AI_AGENT_TAG = 'agent';
export const AI_AGENT_APPLICATION_NAME = 'lightdash-ai';
export const AI_AGENT_SESSION_SETTING = 'lightdash.agent';
export var AiAgentMarkerLevel;
(function (AiAgentMarkerLevel) {
    AiAgentMarkerLevel["VERIFIED_SESSION"] = "verified_session";
    AiAgentMarkerLevel["REQUEST_BOUND"] = "request_bound";
    AiAgentMarkerLevel["IDENTIFY_ONLY"] = "identify_only";
    AiAgentMarkerLevel["NONE"] = "none";
})(AiAgentMarkerLevel || (AiAgentMarkerLevel = {}));
export const AI_PRINCIPAL_QUERY_TAG = 'ai_principal';
export var AgentIdentityConnectEntryPoint;
(function (AgentIdentityConnectEntryPoint) {
    AgentIdentityConnectEntryPoint["CHAT_CARD"] = "chat_card";
    AgentIdentityConnectEntryPoint["MY_WAREHOUSE_CONNECTIONS"] = "my_warehouse_connections";
    AgentIdentityConnectEntryPoint["MY_AGENT_CONNECTIONS"] = "my_agent_connections";
    AgentIdentityConnectEntryPoint["MCP_CONNECT_LINK"] = "mcp_connect_link";
    AgentIdentityConnectEntryPoint["CLI"] = "cli";
    AgentIdentityConnectEntryPoint["MCP_CONSENT"] = "mcp_consent";
    AgentIdentityConnectEntryPoint["OAUTH_CONSENT"] = "oauth_consent";
    AgentIdentityConnectEntryPoint["SLACK_LINK"] = "slack_link";
    AgentIdentityConnectEntryPoint["UNKNOWN"] = "unknown";
})(AgentIdentityConnectEntryPoint || (AgentIdentityConnectEntryPoint = {}));
export var AgentIdentityConnectFailureReason;
(function (AgentIdentityConnectFailureReason) {
    AgentIdentityConnectFailureReason["ACCESS_DENIED"] = "access_denied";
    AgentIdentityConnectFailureReason["OAUTH_ERROR"] = "oauth_error";
    AgentIdentityConnectFailureReason["STATE_MISMATCH"] = "state_mismatch";
    AgentIdentityConnectFailureReason["TOKEN_EXCHANGE_FAILED"] = "token_exchange_failed";
    AgentIdentityConnectFailureReason["NO_REFRESH_TOKEN"] = "no_refresh_token";
    AgentIdentityConnectFailureReason["NOT_AGENT_SESSION"] = "not_agent_session";
    AgentIdentityConnectFailureReason["SESSION_CHECK_FAILED"] = "session_check_failed";
    AgentIdentityConnectFailureReason["LICENSE_REQUIRED"] = "license_required";
    AgentIdentityConnectFailureReason["ORGANIZATION_REQUIRED"] = "organization_required";
    AgentIdentityConnectFailureReason["NOT_CONFIGURED"] = "not_configured";
    AgentIdentityConnectFailureReason["CREDENTIAL_SAVE_FAILED"] = "credential_save_failed";
    AgentIdentityConnectFailureReason["SIGN_IN_FAILED"] = "sign_in_failed";
})(AgentIdentityConnectFailureReason || (AgentIdentityConnectFailureReason = {}));
export var AiAccessRefusalReason;
(function (AiAccessRefusalReason) {
    AiAccessRefusalReason["AGENT_ACCESS_DISABLED"] = "agent_access_disabled";
    AiAccessRefusalReason["AGENT_CAPABILITY_DENIED"] = "agent_capability_denied";
    AiAccessRefusalReason["AGENT_PROJECT_DENIED"] = "agent_project_denied";
    AiAccessRefusalReason["AGENT_RAW_SQL_UNCONFIRMED"] = "agent_raw_sql_unconfirmed";
    AiAccessRefusalReason["AGENT_OPERATION_UNMAPPED"] = "agent_operation_unmapped";
    AiAccessRefusalReason["AGENT_ACTOR_UNVERIFIED"] = "agent_actor_unverified";
    AiAccessRefusalReason["AGENT_SETTING_DENIED"] = "agent_setting_denied";
    AiAccessRefusalReason["AGENT_USER_NOT_ALLOWED"] = "agent_user_not_allowed";
    AiAccessRefusalReason["AGENT_GRANT_DENIED"] = "agent_grant_denied";
    AiAccessRefusalReason["AGENT_GRANT_REVOKED"] = "agent_grant_revoked";
    AiAccessRefusalReason["AGENT_CHANNEL_DENIED"] = "agent_channel_denied";
    AiAccessRefusalReason["AGENT_HUMAN_PERMISSION_DENIED"] = "agent_human_permission_denied";
    AiAccessRefusalReason["RESULT_NOT_AGENT_PRODUCED"] = "result_not_agent_produced";
    AiAccessRefusalReason["PRINCIPAL_FAILED"] = "principal_failed";
    AiAccessRefusalReason["AI_SERVICE_ACCOUNT_MISSING"] = "ai_service_account_missing";
    AiAccessRefusalReason["AI_SERVICE_ACCOUNT_INVALID"] = "ai_service_account_invalid";
    AiAccessRefusalReason["NEEDS_SIGN_IN"] = "needs_sign_in";
    AiAccessRefusalReason["SIGN_IN_EXPIRED"] = "sign_in_expired";
    AiAccessRefusalReason["WAREHOUSE_NOT_SUPPORTED"] = "warehouse_not_supported";
    AiAccessRefusalReason["SERVICE_ACCOUNT"] = "service_account";
    AiAccessRefusalReason["EMBED_NOT_SUPPORTED"] = "embed_not_supported";
})(AiAccessRefusalReason || (AiAccessRefusalReason = {}));
export var AiAccessRefusalAction;
(function (AiAccessRefusalAction) {
    AiAccessRefusalAction["SIGN_IN"] = "sign_in";
    AiAccessRefusalAction["ASK_ADMIN"] = "ask_admin";
})(AiAccessRefusalAction || (AiAccessRefusalAction = {}));
export const AI_ACCESS_REFUSED_CODE = 'ai_access_refused';
export const getAiAccessRefusalMessage = (reason, { projectName }) => {
    switch (reason) {
        case AiAccessRefusalReason.AGENT_ACCESS_DISABLED:
            return 'Agents are disabled. Ask an organization admin to enable agent access.';
        case AiAccessRefusalReason.AGENT_CAPABILITY_DENIED:
            return 'Agents cannot do this here. Ask an admin to review agent permissions.';
        case AiAccessRefusalReason.AGENT_PROJECT_DENIED:
            return 'Agents cannot access this project. Ask an organization admin to allow it.';
        case AiAccessRefusalReason.AGENT_RAW_SQL_UNCONFIRMED:
            return 'Raw SQL needs a warehouse restriction confirmation. Ask a project admin to confirm the current agent connection.';
        case AiAccessRefusalReason.AGENT_OPERATION_UNMAPPED:
            return 'This operation has no agent permission mapping. Contact an admin for support.';
        case AiAccessRefusalReason.AGENT_ACTOR_UNVERIFIED:
            return 'Connect your Slack account so agents can run as you.';
        case AiAccessRefusalReason.AGENT_SETTING_DENIED:
            return 'Agent content writes are disabled. Ask an organization admin to enable them.';
        case AiAccessRefusalReason.AGENT_USER_NOT_ALLOWED:
            return 'Your account is not allowed to use agents. Ask an organization admin to update agent access.';
        case AiAccessRefusalReason.AGENT_GRANT_DENIED:
            return 'This connection does not allow the operation. Reconnect with the required permissions.';
        case AiAccessRefusalReason.AGENT_GRANT_REVOKED:
            return 'This connection was revoked. Reconnect before using the agent.';
        case AiAccessRefusalReason.AGENT_CHANNEL_DENIED:
            return 'This channel is not allowed to use the agent. Ask an admin to update its channel settings.';
        case AiAccessRefusalReason.AGENT_HUMAN_PERMISSION_DENIED:
            return 'Your account cannot perform this operation. Ask an admin to update your project permissions.';
        case AiAccessRefusalReason.AI_SERVICE_ACCOUNT_MISSING:
            return `Agents can't run on ${projectName ?? 'this project'} yet. It needs a shared agent account. A project admin can add one in Agent identity.`;
        case AiAccessRefusalReason.AI_SERVICE_ACCOUNT_INVALID:
            return `Agents can't run on ${projectName ?? 'this project'} right now. Its shared agent account failed to sign in. A project admin can check it in Agent identity.`;
        case AiAccessRefusalReason.RESULT_NOT_AGENT_PRODUCED:
            return "Agents can't use these results because your current agent sign-in didn't produce them. Run the query again through your agent.";
        case AiAccessRefusalReason.PRINCIPAL_FAILED:
            return 'The last check of your agent identity failed. Ask an admin to review it.';
        case AiAccessRefusalReason.SIGN_IN_EXPIRED:
            return 'Your agent sign-in expired. Connect your agent again.';
        case AiAccessRefusalReason.NEEDS_SIGN_IN:
            return 'Connect your agent to the warehouse once so it can run as you.';
        case AiAccessRefusalReason.WAREHOUSE_NOT_SUPPORTED:
            return 'Agent identity is not available for this warehouse yet.';
        case AiAccessRefusalReason.EMBED_NOT_SUPPORTED:
            return "Agents run as a signed-in person on this connection. Embedded viewers can't use them.";
        case AiAccessRefusalReason.SERVICE_ACCOUNT:
            return "Agents run as a person on this connection. Service accounts can't use them.";
        default:
            return assertUnreachable(reason, 'Unknown AI access refusal reason');
    }
};
export const getAgentCapabilityRefusalMessage = (reason, policyLayer, capability) => {
    if (capability !== null) {
        const name = getAgentCapabilityName(capability);
        if (reason === AiAccessRefusalReason.AGENT_CAPABILITY_DENIED) {
            return policyLayer === 'org_ceiling' ||
                policyLayer === 'organization_setting'
                ? `Your organization's agent permissions do not allow ${name}. Ask an admin to change Permissions on the Agents page.`
                : `Agents cannot use ${name} here. Ask an admin to review agent permissions.`;
        }
        if (reason === AiAccessRefusalReason.AGENT_HUMAN_PERMISSION_DENIED) {
            return `Your roles do not allow ${name}. Ask an admin to review your permissions.`;
        }
    }
    return getAiAccessRefusalMessage(reason, { projectName: null });
};
export const getAiAccessRefusalAction = (reason) => {
    switch (reason) {
        case AiAccessRefusalReason.AGENT_ACCESS_DISABLED:
        case AiAccessRefusalReason.AGENT_CAPABILITY_DENIED:
        case AiAccessRefusalReason.AGENT_PROJECT_DENIED:
        case AiAccessRefusalReason.AGENT_RAW_SQL_UNCONFIRMED:
        case AiAccessRefusalReason.AGENT_OPERATION_UNMAPPED:
        case AiAccessRefusalReason.AGENT_SETTING_DENIED:
        case AiAccessRefusalReason.AGENT_USER_NOT_ALLOWED:
        case AiAccessRefusalReason.AGENT_GRANT_DENIED:
        case AiAccessRefusalReason.AGENT_GRANT_REVOKED:
        case AiAccessRefusalReason.AGENT_CHANNEL_DENIED:
        case AiAccessRefusalReason.AGENT_HUMAN_PERMISSION_DENIED:
            return AiAccessRefusalAction.ASK_ADMIN;
        case AiAccessRefusalReason.AGENT_ACTOR_UNVERIFIED:
        case AiAccessRefusalReason.SIGN_IN_EXPIRED:
        case AiAccessRefusalReason.NEEDS_SIGN_IN:
            return AiAccessRefusalAction.SIGN_IN;
        case AiAccessRefusalReason.PRINCIPAL_FAILED:
        case AiAccessRefusalReason.AI_SERVICE_ACCOUNT_MISSING:
        case AiAccessRefusalReason.AI_SERVICE_ACCOUNT_INVALID:
            return AiAccessRefusalAction.ASK_ADMIN;
        case AiAccessRefusalReason.RESULT_NOT_AGENT_PRODUCED:
        case AiAccessRefusalReason.EMBED_NOT_SUPPORTED:
        case AiAccessRefusalReason.WAREHOUSE_NOT_SUPPORTED:
        case AiAccessRefusalReason.SERVICE_ACCOUNT:
            return null;
        default:
            return assertUnreachable(reason, 'Unknown AI access refusal reason');
    }
};
export const getAiAccessRefusalSettingsUrl = (reason, projectUuid) => {
    switch (reason) {
        case AiAccessRefusalReason.AGENT_ACCESS_DISABLED:
        case AiAccessRefusalReason.AGENT_CAPABILITY_DENIED:
        case AiAccessRefusalReason.AGENT_PROJECT_DENIED:
        case AiAccessRefusalReason.AGENT_SETTING_DENIED:
        case AiAccessRefusalReason.AGENT_USER_NOT_ALLOWED:
        case AiAccessRefusalReason.AGENT_GRANT_DENIED:
        case AiAccessRefusalReason.AGENT_GRANT_REVOKED:
        case AiAccessRefusalReason.AGENT_CHANNEL_DENIED:
        case AiAccessRefusalReason.AGENT_HUMAN_PERMISSION_DENIED:
            return AGENT_IDENTITY_SETTINGS_PATH;
        case AiAccessRefusalReason.AGENT_RAW_SQL_UNCONFIRMED:
            return projectUuid === null
                ? AGENT_IDENTITY_SETTINGS_PATH
                : getProjectAgentIdentitySettingsPath(projectUuid);
        case AiAccessRefusalReason.AI_SERVICE_ACCOUNT_MISSING:
        case AiAccessRefusalReason.AI_SERVICE_ACCOUNT_INVALID:
            return projectUuid === null
                ? null
                : getProjectAgentIdentitySettingsPath(projectUuid);
        case AiAccessRefusalReason.AGENT_ACTOR_UNVERIFIED:
        case AiAccessRefusalReason.AGENT_OPERATION_UNMAPPED:
        case AiAccessRefusalReason.RESULT_NOT_AGENT_PRODUCED:
        case AiAccessRefusalReason.PRINCIPAL_FAILED:
        case AiAccessRefusalReason.NEEDS_SIGN_IN:
        case AiAccessRefusalReason.SIGN_IN_EXPIRED:
        case AiAccessRefusalReason.WAREHOUSE_NOT_SUPPORTED:
        case AiAccessRefusalReason.SERVICE_ACCOUNT:
        case AiAccessRefusalReason.EMBED_NOT_SUPPORTED:
            return null;
        default:
            return assertUnreachable(reason, 'Unknown AI access refusal reason');
    }
};
export const isAiAccessRefusal = (value) => typeof value === 'object' &&
    value !== null &&
    value.code === AI_ACCESS_REFUSED_CODE &&
    typeof value.message === 'string';
export const getAiExecutionCredentialUuid = (plan) => {
    if (plan === null)
        return null;
    switch (plan.identity) {
        case 'connected_person':
        case 'ai_service_account':
            return plan.identityUuid;
        case 'marked_person':
            return null;
        default:
            return assertUnreachable(plan, 'Unknown AI execution identity');
    }
};
//# sourceMappingURL=aiPrincipal.js.map